export default function pluralize(str, n) {
    const suffix = str.endsWith("x") ? "es" : "s";
    const nStr = `${n}`;
    return nStr === "1"
        ? str
        : str + suffix;
}
//# sourceMappingURL=pluralize.js.map